module.exports = __webpack_public_path__ + "static/media/tickets-outline.c2c05f27.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tickets-outline.svg
// module id = 711
// module chunks = 0